// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xa3C","right":"styles_right__23iKk"};